<div class="container-fluid p-3 m-0" [class.hide-pointer]="hidePointer" style="overflow-x: auto; overflow-y: hidden">
    <div class="mt-2 mb-3">
        <div class="table-responsive">
            <table mat-table [dataSource]="_dataSource">
                <ng-container [matColumnDef]="column.column" *ngFor="let column of displayedColumns">
                    <ng-container *ngIf="column.column !== 'action'">
                        <th mat-header-cell *matHeaderCellDef>{{ column.display }}</th>
                    </ng-container>
                    <ng-container *ngIf="column.column === 'action'">
                        <th mat-header-cell *matHeaderCellDef>{{ column.display }}</th>
                    </ng-container>
                    <ng-container [ngSwitch]="column.column">
                        <ng-container *ngSwitchCase="'pillStatus'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]">
                                    <app-pill [backgroundColor]="this.getColor(element[column.column])" fontColor="white"
                                        [text]="element[column.column]"></app-pill>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'price'">
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element[column.column]==='View Night Ranges'; else priceDefault">
                                    <span class="view-range" (click)="onActionButtonClick($event, element)">{{
                                        element[column.column] }}</span>
                                </ng-container>
                                <ng-template #priceDefault>{{ element[column.column] }}</ng-template>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'organizationPolicyButtons'">
                            <td mat-cell *matCellDef="let element" style="width:14%;">
                                <span matTooltip="Edit" [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                    <button mat-mini-fab class="edit-table-button" (click)="onEditPolicyButtonClick($event, element)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </span>
                                <span matTooltip="Set/Remove Primary" [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                    <button mat-mini-fab class="edit-table-button" (click)="onUpdatePrimaryPolicyClick($event, element)" [ngClass]="{'set': element.pillStatus === ''}" [disabled]="tableLength === 1">
                                        <mat-icon>indeterminate_check_box</mat-icon>
                                    </button>
                                </span>
                                <span matTooltip="Delete" [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                    <button mat-mini-fab class="delete-table-button" (click)="onDeletePolicyButtonClick($event, element)" [disabled]="tableLength === 1 || element.pillStatus === 'Primary'" >
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'propertyPolicyButtons'">
                            <td mat-cell *matCellDef="let element" style="width:14%;">
                                <span matTooltip="Edit" [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                    <button mat-mini-fab class="edit-table-button" (click)="onEditPolicyButtonClick($event, element)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </span>
                                <span matTooltip="Set/Clear Primary" [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                    <button mat-mini-fab class="edit-table-button" (click)="onUpdatePrimaryPolicyClick($event, element)" [ngClass]="{'set': element.pillStatus === ''}" [disabled]="tableLength === 1">
                                        <mat-icon>indeterminate_check_box</mat-icon>
                                    </button>
                                </span>
                                <span matTooltip="Delete" [matTooltipPosition]="'above'" matTooltipHideDelay="250">
                                    <button mat-mini-fab class="delete-table-button" (click)="onDeletePolicyButtonClick($event, element)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'action'">
                            <td mat-cell *matCellDef="let element">
                                <button mat-raised-button class="edit-table-button" (click)="onSelectPolicyButtonClick($event, element)">
                                    {{ actionButtonText }}
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'remove'">
                            <td mat-cell *matCellDef="let element">
                                <button mat-raised-button class="warn-button" (click)="onSelectPolicyButtonClick($event, element)">
                                    {{ actionButtonText }}
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnNames"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnNames;" (click)="onRowClick(row)" [ngClass]="{'highlight': selectedRowIndex === row}"></tr>
                <ng-container *ngIf="!displayLoadingIndicator.value">
                    <tr class="mat-row" *matNoDataRow style="border:0px solid white;">
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            @if(_dataSource.data.length === 0) {
                                No {{ component }} data
                            } @else {
                                Loading {{ component }}..
                            }
                        </td>
                    </tr>
                </ng-container>
            </table>
        </div>
        <div *ngIf="displayLoadingIndicator.value" class="d-flex justify-content-center">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <div *ngIf="!propertyHasPrimaryPolicy" style="margin-top:60px;">
        <hr>
        <div class="mt-4">
            <mat-action-row class="mt-4 d-flex justify-content-center">
                <div class="d-flex justify-content-center align-items-center text-muted">
                    <span class="required-input">*</span>&nbsp;- Property does not have a selected primary Policy.  Organization's default policy will be assigned.
                </div>
            </mat-action-row>
        </div>
    </div>
</div>